'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('services.businessProcess', [])

.factory('businessProcessService', ['$http', '$q', function ($http, $q) {

    var service = {};

    // Business Process
    service.getAllBusinessProcessesAndRelated = function () {
        return $http.get(environment.apiUrl + '/ID/API/BusinessProcess/AndRelated',
                         { cache: true })
                    .then(function (response) {
                        return response.data;
                    });
    }

    // Business Tasks
    service.getBusinessTasksByBusinessActivity = function (businessActivityId) {
        return $http.get(environment.apiUrl + '/ID/API/BusinessTask/ByBusinessActivityID/' + businessActivityId,
                         { cache: true })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getBusinessTaskByID = function (businessTaskId) {
        return $http.get(environment.apiUrl + '/ID/API/BusinessTask/' + businessTaskId,
                         { cache: true })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getBusinessTaskSystemRoleByBusinessTaskID = function (businessTaskId) {
        return $http.get(environment.apiUrl + '/ID/API/BusinessTaskSystemRole/ByBusinessTaskID/' + businessTaskId,
                         {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    return service;
}]);
